module.exports = ".cabezera {\n  background: #253a5b;\n  color: white; }\n\n.cabezera-card {\n  border-color: #253a5b; }\n\n.btnContabilidad {\n  background-color: transparent;\n  border: 1px solid white;\n  color: white;\n  padding: 0 20px;\n  margin: 0 2px; }\n\n.btnContabilidad:hover {\n    background-color: rgba(255, 255, 255, 0.1); }\n\n.btnContabilidad:focus {\n    outline: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/conciliacionBancaria/consultar/conciliacionBancaria-consultar.component.scss
// module id = ./src/app/Contabilidad/conciliacionBancaria/consultar/conciliacionBancaria-consultar.component.scss
// module chunks = main